import { Pre } from "components/general"

const NFTDetails = ({ data }: { data: object }) => {
  return <Pre height={120}>{data}</Pre>
}

export default NFTDetails
